import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { IAxBirthDateInitData } from "../Global/AxBirthDateInputTriple";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxDropdown, AxFormValidation, IAxDropdownOptions } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AccountStorageService } from "../../Service/Account/AccountStorageService";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";

@ModuleName("Registration")
export class Registration implements AxInit {
    constructor(private _storage = new AccountStorageService(),
        private _requestHelper = new RequestHelper()) { }

    private _CountryDropDown: AxDropdown = new AxDropdown();
    private _CommunicationLanguage: AxDropdown = new AxDropdown();
    private _RentalWeightDropDown: AxDropdown = new AxDropdown();
    private _RentalHeightDropDown: AxDropdown = new AxDropdown();
    private _RentalShowSizeDropDown: AxDropdown = new AxDropdown();
    private _RentalSkiLevelDropDown: AxDropdown = new AxDropdown();
    private _GenderDropdown: AxDropdown = new AxDropdown();


    private countryList: CountryList[] = [];
    private parentSelector;

    private subDivisionSearchTimeout: NodeJS.Timeout;
    private _I18nHelper = new I18nHelper;

    AxInit(init: IRegistrationData): void {
        this._storage.init(init.formData);
        this.parentSelector = init.parentId;

        AxLoad.LoadModule('AxBirthDateInputTriple', init);
        AxLoad.LoadModule('RegisterForm', init);

        let currentUrl = new URL(window.location.href);
        if (!this._storage.isAccountPage(currentUrl)) {
            history.replaceState({}, $(document).find("title").text(), init.loginUrl);
        }
        let currentStorage = this._storage.getStorage();
        if (currentStorage?.referrer != null && currentStorage.referrer.toLowerCase().indexOf('shoppingcart') !== -1) {
            $('[data-login="guest"]').removeClass('d-none');
            $('[data-altcha-login]').addClass('login-guest');
        }

        this._GenderDropdown.init(`${init.parentId} .accountsettings__gender`);

        this._CountryDropDown.init(`${init.parentId} .register__countryCode`,
            {
                searchBar: true,
                multiSelect: false,
                onSelect: (x, y) => {
                    this.subDivisionSearchTimeout = setTimeout(() => {
                        this.searchSubDivision();
                    }, 200);
                    $('#RegCountryCode').val(y)
                }
            });

        this._CommunicationLanguage.init('.register__language', {
            searchBar: false,
            multiSelect: false,
            onSelect: (x, y) => {
                $('#Language').val(y);
            }
        });

        $(`.accountsettings__postalCode`).on("keyup", () => {
            if (typeof this.subDivisionSearchTimeout != 'undefined') {
                clearTimeout(this.subDivisionSearchTimeout);
            }

            this.subDivisionSearchTimeout = setTimeout(() => {
                this.searchSubDivision();
            }, 200);
        });

        $(init.rental_parentId).on("change", "input[type=radio]", (e) => {
            let rentalViewModel = {
                Height: $("#RentalHeight").val(),
                Weight: $("#RentalWeight").val(),
                ShoeSize: $("#RentalShoeSize").val(),
                SkiLevel: $("#RentalSkiLevel").val()
            };

            AxessViewer.loadPartialView('/Account/GetAccRentalInfo', {
                rentalViewModel: rentalViewModel,
                unit: e.currentTarget.value
            }, (resp) => {
                $('#registration__rentalContainer').html(resp.view);
                this.initRentDropdowns(this);
            }, null);
        });
        this.initRentDropdowns(this);

        //GuestForm
        new AxFormValidation({
            selector: '#guestForm',
            rules: {
                guestEmail: {
                    required: true,
                    email: true,
                    regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
                },
                guestConfirmEmail: {
                    required: true,
                    equalTo: "#guestEmail"
                },
            }
        }).init();

        $('[data-checkout="guest"]').on('click', () => {
            this.guestCheckout();
        });
    }

    guestCheckout() {
        let currentStorage = this._storage.getStorage();
        if (currentStorage?.referrer != null && currentStorage.referrer.toLowerCase().indexOf('shoppingcart') !== -1) {
            $('[data-login="guest"]').removeClass('d-none');
            $('[data-altcha-login]').addClass('login-guest');
        }
        const hasValues = $('#guestEmail').val() !== '' && $('#guestConfirmEmail').val() !== '';
        const hasSameValue = $('#guestConfirmEmail').length == 0 || $('#guestEmail').val() === $('#guestConfirmEmail').val();
        const hasGuestFieldErrors = $('#guestEmail').hasClass('field-error') || $('#guestConfirmEmail').hasClass('field-error');

        if (hasValues && hasSameValue && !hasGuestFieldErrors) {
            currentStorage.data.BuyerEmail = $('#guestEmail').val();
            currentStorage.data.CaptchaToken = $('#CaptchaToken').val();
            this._requestHelper.postToUrl(currentStorage.target, currentStorage.data);
        }
    }

    searchSubDivision() {
        let $selected: JQuery<HTMLElement> = this._CountryDropDown.getSelected();

        if (typeof $selected == "undefined" || $selected.length === 0) return;

        let isoCode = $selected.attr('data-iso') as string;

        if (isoCode === '') return;

        let countryEntry: CountryList = this.countryList.find(x => x.isoCode === isoCode);

        if (typeof countryEntry != 'undefined') {
            this.printSubDivision(countryEntry.subDivisionList);
            return;
        }

        AxessViewer.loadPartialView('/AccUtil/GetSubDivisionList',
            { iso2Code: isoCode },
            (res: SubDivisionWithCodeList[]) => {
                this.countryList.push({
                    isoCode: isoCode,
                    subDivisionList: res
                });
                this.printSubDivision(res);
            }, {});
    }

    printSubDivision(subDivisionList: SubDivisionWithCodeList[]) {
        let postalCode = this.getPostalCode();
        let $dropDownParent: JQuery<HTMLElement> = $(this._CountryDropDown.getElements()[0]);
        let $stateField = $dropDownParent.next('.state-field');

        if (typeof postalCode != 'undefined' && postalCode.length === 0) {
            this.removePostalCodeInfo($stateField);
            return;
        };

        let selectedDivision: SubDivisionWithCodeList = subDivisionList.find((x: SubDivisionWithCodeList) => x.PostalCodes.includes(postalCode));

        if (typeof selectedDivision == 'undefined') {
            this.removePostalCodeInfo($stateField);
            return;
        }

        if ($stateField.length > 0) {
            this.removePostalCodeInfo($stateField);
            return;
        }

        if ($stateField.length === 0) {
            let newInfoDiv = document.createElement('div');
            newInfoDiv.classList.add('ax-form-group');
            newInfoDiv.classList.add('ax-mt-1');
            newInfoDiv.classList.add('state-field');

            let newInfoInput = document.createElement('input');
            newInfoInput.setAttribute('type', 'text');
            newInfoInput.setAttribute('disabled', 'disabled');
            newInfoInput.setAttribute('value', selectedDivision.SubDivision.SubDivisionName);
            newInfoInput.classList.add('ax-form-control');


            let newInfoLabel = document.createElement('label');
            newInfoLabel.classList.add('ax-form-label');
            newInfoLabel.innerText = `${this._I18nHelper.GetTranslation(Translations.State)}`;

            let newInfoDivGroupAssistance = document.createElement('div');
            newInfoDivGroupAssistance.classList.add('ax-form-group-assistence');

            newInfoDiv.appendChild(newInfoInput);
            newInfoDiv.appendChild(newInfoLabel);
            newInfoDiv.appendChild(newInfoDivGroupAssistance);

            $dropDownParent.after(newInfoDiv);
            $stateField = $dropDownParent.next('.state-field');
        }
    }

    removePostalCodeInfo($stateField: JQuery<HTMLElement>): void {
        $stateField.remove();
    }

    getPostalCode(): string {
        return $(`${this.parentSelector} .register__postalCode`).val() as string;
    }

    initRentDropdowns(that) {
        this._RentalWeightDropDown.init(`.accountsettings__rentalWeight`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalWeight').val(value);
                }
            }
        );

        this._RentalHeightDropDown.init(`.accountsettings__rentalHeight`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalHeight').val(value);
                }
            }
        );

        this._RentalShowSizeDropDown.init(`.accountsettings__rentalShoeSize`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalShoeSize').val(value);
                }
            }
        );

        this._RentalSkiLevelDropDown.init(`.accountsettings__rentalSkiLevel`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalSkiLevel').val(value);
                }
            }
        );
    }
}

interface IRegistrationData extends IAxBirthDateInitData {
    birthdayPattern: string;
    parentId: string;
    rental_parentId: string;
    outputTarget: string;
    setDay: string;
    setMonth: string;
    setYear: string;
    setBirthDate: string;
    formData: any;
    loginUrl: string;
}

class CountryList {
    isoCode: string;
    subDivisionList: SubDivisionWithCodeList[];
}

class SubDivisionWithCodeList {
    SubDivision: CustomerSubDivision;
    PostalCodes: string[];
}

class CustomerSubDivision {
    SubDivisionCode: string;
    SubDivisionName: string;
}